import { includes, map, get, filter, isEmpty, every, groupBy, presence, some } from 'lodash'

const filteredPhysicalAssets = (filters, assets) => filter(assets, (asset) => {
  const filterResults = {}

  if (filters.location != 'All') {
    filterResults['location'] =
      includes(map(filters.location, 'value'), get(asset, 'location')) || includes(map(filters.location, 'value'), get(asset, 'site_id'))
  }

  if (filters.manufacturer != 'All') {
    filterResults['manufacturer'] = includes(map(filters.manufacturer, 'value'), get(asset, 'manufacturer'))
  }

  if (filters.type != 'All') {
    filterResults['type'] = includes(map(filters.type, 'value'), get(asset, 'type'))
  }

  if (filters.model != 'All') {
    filterResults['model'] = includes(map(filters.model, 'value'), get(asset, 'model'))
  }

  if (filters.cloudcore != 'All') {
    filterResults['cloudcore'] = includes(map(filters.cloudcore, 'value'), get(asset, 'cloudcore'))
  }

  if (filters.status != 'All') {
    filterResults['status'] = includes(map(filters.status, 'value'), get(asset, 'status'))
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

export { filteredPhysicalAssets }
